<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    hotel_class
                </mat-icon>
                <app-search-marquee #searchMarquee [searchRequestTypeEnum]="searchRequestTypeEnum"
                                    [searchRequestTileComponentTypeName]="searchRequestTileComponentTypeName"
                                    [disabled]="isSearchMarqueeDisabled">
                </app-search-marquee>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                <!--Enter search criteria to locate resources-->
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <br />
                <table *ngIf="searchResult && searchResult.length > 0" mat-table [dataSource]="searchResultDatasource" class="search-result mat-elevation-z8" matSort>
                    <ng-container matColumnDef="Avatar">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                        <td mat-cell *matCellDef="let resource" (click)="editItem(resource)">
                            <app-image srcPath="{{ resource.AvatarBlobPath == null ? appService.defaultImageUri : resource.AvatarBlobPath }}" isApiImage="{{ resource.AvatarBlobPath == null ? 'false' : 'true' }}" (click)="editItem(resource)" class="margin-wide-right nudge-down-small" className="app-image-extra-small app-image-circle"></app-image>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="FirstName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
                        <td mat-cell *matCellDef="let resource" (click)="editItem(resource.ResourceId)">
                            {{resource.FirstName}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="LastName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
                        <td mat-cell *matCellDef="let resource" (click)="editItem(resource.ResourceId)">
                            {{resource.LastName}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Delete">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                        <td mat-cell *matCellDef="let resource">
                            <button mat-button (click)="deleteItem(resource.ResourceId, resource.FirstName + ' ' + resource.LastName)">
                                <mat-icon class="material-symbols-outlined">
                                    delete_forever
                                </mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </form>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>
